import globalStore from "store2";

export const store = globalStore.namespace("toggl-hire-candidate-portal");
